import { ConditionalDisplay } from '@rsos/base-components';
import useIsInteragencyChatEnabled from '@rsos/hooks/useIsInteragencyChatEnabled';
import styles from '../settings.module.css';
import { AgencyConversationsNotificationSettings } from './AgencyConversationsNotificationSettings';

/**
 * "Agency Conversations" section of the Admin > Notifications page. Only shown to
 * agencies that actually have interagency chat, so admins without the feature are
 * not offered settings for it.
 */
export function AgencyConversationsSettings() {
  const isInteragencyChatEnabled = useIsInteragencyChatEnabled();

  return (
    <ConditionalDisplay
      dataName="agency-conversations-settings"
      conditions={[
        {
          showIf: isInteragencyChatEnabled,
          reason:
            'Needs the interagency_chat capability and the INTERAGENCY_CHAT permission',
        },
      ]}
    >
      <div className={styles.section} data-name="agency-conversations-section">
        <h2 className={styles.title}>Agency Conversations</h2>
        <div className={styles.description}>
          Manage notifications for conversations between agencies.
        </div>
        <div className={styles.cardBlock}>
          <AgencyConversationsNotificationSettings />
        </div>
      </div>
    </ConditionalDisplay>
  );
}
